function createBody(data) {
  if (!data) {
    return data;
  }

  if (data instanceof FormData) {
    return data;
  }

  if (typeof data === 'string') {
    return data;
  }

  const params = new URLSearchParams();
  Object.keys(data).forEach(key => params.append(key, data[key]));
  return params.toString();
}

export const FETCH_BEFORE = 'fetch:before';
export const FETCH_AFTER = 'fetch:after';
export const IO_ERROR = 'io:error';

export class Ajax {
  constructor(base) {
    riot.observable(this);
    this.base = base;
  }

  ajax(url, method, body) {
    const option = {
      method,
      body: createBody(body),
      mode: 'cors',
      credentials: 'include'
    };

    if (option.body instanceof URLSearchParams || typeof option.body === 'string') {
      option.headers = {
        'Content-type': 'application/x-www-form-urlencoded'
      };
    }

    return new Promise((resolve, reject) => {
      fetch(url, option)
        .catch(err => {
          this.trigger(IO_ERROR, { status: IO_ERROR });
          reject({ status: IO_ERROR });
        })
        .then(res => {
          if (res == null) {
            throw res;
          }

          if (!res.ok) {
            this.trigger(IO_ERROR, { status: IO_ERROR });
            reject({ status: IO_ERROR, text: res.statusText });
          }
          return res.json();
        })
        .then(res => {
          if (res.status !== 0) {
            this.trigger(IO_ERROR, res);
            reject(res);
          }
          resolve(res);
        })
        .catch(err => {
          this.trigger(IO_ERROR, { status: IO_ERROR });
          reject({ status: IO_ERROR });
        });
    });
  }

  request(path, method, body, background) {
    if (background === false) {
      this.trigger(FETCH_BEFORE);
    }
    return this.ajax(`${this.base}${path}`, method, body)
      .finally(() => this.trigger(FETCH_AFTER));
  }

  get(path, background = false) {
    return this.request(path, 'GET', null, background);
  }

  post(path, body, background = false) {
    return this.request(path, 'POST', body, background);
  }

  patch(path, body, background = false) {
    return this.request(path, 'PATCH', body, background);
  }

  put(path, body, background = false) {
    return this.request(path, 'PUT', body, background);
  }

  delete(path, background = false) {
    return this.request(path, 'DELETE', null, background);
  }
}